import { render, staticRenderFns } from "./bannerDetails.vue?vue&type=template&id=a9d038ba&scoped=true"
import script from "./bannerDetails.vue?vue&type=script&lang=js"
export * from "./bannerDetails.vue?vue&type=script&lang=js"
import style0 from "./bannerDetails.vue?vue&type=style&index=0&id=a9d038ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d038ba",
  null
  
)

export default component.exports